<app-table *ngIf="appointmentData"
           [dataSource]="dataSource"
           [columnDefinition]="displayedColumns"
           [filtersTemplate]="dateFilter"
           [sortingDataAccessor]="sortingDataAccessor"
           [showPaginator]="false">
</app-table>

<ng-template #dateFilter>
  <app-basic-calender [calender]="calender"
                      [control]="dateControl"
                      (selected)="onDateChanege($event)">
  </app-basic-calender>
</ng-template>

<ng-template #statusColumn
            let-item="item">
            <span>{{item}}</span>
</ng-template>

<ng-template #attendanceColumn
            let-item="item"
            let-value="value">
            <ng-container *ngIf="value.disabled">
              <app-nested-menu *ngIf="isAppointmentPending(value)"
                               [menu]="cancelAppointmentOptions"
                               (click)="selectedRow(value)"></app-nested-menu>
            </ng-container>
            <ng-container *ngIf="!value.disabled">
              <app-nested-menu *ngIf="isAppointmentPending(value)"
                               [menu]="attendAppointmentOptions"
                               (click)="selectedRow(value)"></app-nested-menu>
            </ng-container>
            <span *ngIf="value.Status === AppointmentStatus[AppointmentStatus.Rejected]">Appointment Canceled</span>
            <span *ngIf="value.Status === AppointmentStatus[AppointmentStatus.Unavailable]">Patient is unavailable</span>
            <app-nested-menu *ngIf="isAppointmentCompleted(value)"
                              [menu]="prescribeMedicineOptions"
                              (click)="selectedRow(value)"></app-nested-menu>
</ng-template>